<template>
  <div class="live universal">
    <h1 class="page-title">直播 · 训练营 · {{date_content.count||0}}</h1>

    <None v-if="date_content.list==null ||date_content.list.length == 0" />
    <div v-else>
      <LiveContentItem
        v-for="(item,index) in date_content.list"
        :key="item.id"
        :dateObject="item"
        :index="(index + 1 + (pageInfo.current - 1) * pageInfo.pageSize)"
      />
    </div>
    <DevPagination
      class="margin-top-66"
      :total="date_content.count"
      :pageSize="10"
      :change="change"
      @currentChange="postDate"
    />
  </div>
</template>

<script>
import DevPagination from "@/components/Base/DevPagination.vue";
import LiveContentItem from "@/components/Course/LiveContentItem.vue";
import None from "@/components/Base/None.vue";
import { getLiveVideoList } from "@/utils/api";

export default {
  components: {
    DevPagination,
    LiveContentItem,
    None,
  },
  data() {
    return {
      date_content: {},
      change: false,
      pageInfo: "",
    };
  },
  methods: {
    postDate(page) {
      this.pageInfo = page;
      this.date_content.list = [];
      this.$store.dispatch("changeLoading", true);
      getLiveVideoList({
        page: page.current,
        size: page.pageSize,
      }).then((response) => {
        this.date_content = response.data.data;
        this.$store.dispatch("changeLoading", false);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.live {
  .margin-top-66 {
    margin-top: 66px;
  }
}
</style>
